"use strict";

/**
 * TODO: Replace this module with document.activeElement
 * This module tracks the last focused element via keypress events.
 * We don't need it anymore, since document.activeElement could be used to track the current focused element.
 * In the long run we should refactor it, but there are a cases which are not clear, for example:
 * - "last focused element" => document.activeElement doesn't give that, so we need a way to bypass that.
 */

const globals = require("js/globals");

const MODULE = "FocusTracker";
const tracker = globals.getStorage(MODULE, "focusTracker", { focus: null });

function __current() {
    return tracker.focus;
}

module.exports.register = function (element) {
    element.addEventListener("keydown", (e) => {
        __log(element, "keydown");
        tracker.focus = element;
    });

    element.addEventListener("click", (e) => {
        __log(element, "click");
        tracker.focus = element;
    });
};

module.exports.focusOn = function (element) {
    __log(element, "requested");
    tracker.focus = element;
};

module.exports.current = __current;

module.exports.hasLastFocus = function (element) {
    const current = __current();

    if (element === current) {
        return true;
    } else {
        while (element.parentElement != null) {
            element = element.parentElement;

            if (element === current) {
                return true;
            }
        }

        return false;
    }
};

function __log(element, where) {
    if (__current() != element) {
        console.log(`FocusTracker (${where}) to: `, element);
    }
}
